class TgGalleryHomepage extends HTMLElement {
  connectedCallback(){if(this.cleanup)return;const node=this.querySelector('[data-tg-config]');if(!node)return;let config;try{config=JSON.parse(node.textContent);}catch{return;}if(config.products.some(p=>!p.id||!p.variants.length))return;this.cleanup=this.start(config);}
  disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
  start(config){
    const root=this,prefix=root.dataset.prefix,abort=new AbortController(),observers=[];
    const on=(target,type,fn,options={})=>target?.addEventListener(type,fn,{...options,signal:abort.signal});
    const makeObserver=(fn,options)=>{const observer=new IntersectionObserver(fn,options);observers.push(observer);return observer;};
    const selector=s=>s.replace(/#([a-zA-Z][\w-]*)/g,(_,id)=>'[data-tg-id="'+id+'"]');
    const $=(s,context=root)=>context.querySelector(selector(s));
    const $$=(s,context=root)=>[...context.querySelectorAll(selector(s))];
    const money=value=>new Intl.NumberFormat(config.locale,{style:'currency',currency:config.currency}).format(value);
    const fmt=(s,values)=>s.replace(/__([A-Z_]+)__/g,(_,key)=>values[key.toLowerCase()]??'');
    const normalizeProduct=p=>{p.variants=p.variants.map(v=>{const lower=v.title.toLowerCase(),match=v.title.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);return {...v,id:String(v.id),price:v.price/100,finish:lower.includes('black')?'black':lower.includes('white')?'white':'canvas',wrap:lower.includes('full image')?'full':'mirror',size:match?match[1]+' × '+match[2]:''};});const canvas=p.variants.filter(v=>v.finish==='canvas');p.minPrice=Math.min(...(canvas.length?canvas:p.variants).map(v=>v.price));p.variants.forEach(v=>{if(v.image&&!p.photos[v.finish])p.photos[v.finish]=v.image;});return p;};
    const ensureFinish=(p,current,buttons,dataKey)=>{const present=[...new Set(p.variants.map(v=>v.finish))];const chosen=present.includes(current)?current:present[0];buttons.forEach(b=>{b.disabled=!present.includes(b.dataset[dataKey]);b.setAttribute('aria-pressed',String(b.dataset[dataKey]===chosen));});return chosen;};

  const products=config.products.map(normalizeProduct); const ui=config.ui; const materials=config.materials; const byKey=key=>products.find(p=>p.key===key);

  const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
  let motionEnabled = config.motion && !motionPreference.matches;
  const rotators = [];
  const descriptions=Object.fromEntries(products.map(p=>[p.key,p.description]));
  const finishName=finish=>({black:ui.black_frame,white:ui.white_frame,canvas:ui.stretched_canvas})[finish];
  const variantsFor = (product,finish) => product.variants.filter(variant => variant.finish === finish);
  function showArt(element, product, finish='black') {
    element.dataset.piece = product.key;
    element.style.setProperty('--art-ratio',product.aspect);
    element.style.setProperty('--image-width',product.imageWidth);
    const img = $('img',element);
    img.removeAttribute('srcset'); img.src=product.photos[finish]||product.featured; 
    img.alt=product.name+' — '+finishName(finish);
    element.classList.remove('art-changing');
    if (motionEnabled) { void element.offsetWidth; element.classList.add('art-changing'); }
  }
  function setPressed(buttons, chosen) {buttons.forEach(button => button.setAttribute('aria-pressed',String(button === chosen)));}
  function populateSizes(select, product, finish, preferred) {
    const variants = variantsFor(product,finish); if(!variants.length)return null;
    select.replaceChildren(...variants.map(variant => {
      const option = document.createElement('option');
      option.value=variant.id;
      option.textContent=variant.size?`${variant.size} ${ui.inches}${finish==='canvas'?' · '+(variant.wrap==='full'?ui.full_edge:ui.mirror_edge):''}${variant.available?'':' · '+ui.sold_out}`:variant.title;
      return option;
    }));
    const selected = variants.find(variant => variant.id === preferred?.id) || variants.find(variant => variant.size === preferred?.size && variant.wrap === preferred?.wrap) || variants.find(variant => variant.size === preferred?.size) || variants.find(v=>v.available) || variants[0];
    select.value=selected.id;
    return selected;
  }

  const moods={
    cow:{index:'01',note:ui.little_hero_canvas_art,line:ui.a_little_hero_with_a_big_personality},
    heart:{index:'02',note:ui.a_quiet_statement_canvas_art,line:ui.one_red_heart_with_a_world_of_feeling},
    coast:{index:'03',note:ui.a_change_of_scenery_canvas_art,line:ui.a_little_escape_every_single_day}
  };
  const moodButtons=$$('.mood-picker [data-mood]');
  let heroRotator;
  function renderMood(key) {
    const product=byKey(key), mood=moods[key];
    const button=moodButtons.find(button => button.dataset.mood === key);
    setPressed(moodButtons,button);
    $('#hero').dataset.mood=key;
    showArt($('#hero-art'),product,key === 'cow' ? 'black' : 'white'); $('#hero').style.setProperty('--hero-bg',product.surface);$('#hero').style.setProperty('--hero-text',product.ink);$('#hero').style.setProperty('--hero-muted',product.ink); 
    $('#hero-index').textContent=`${mood.index} / 03`;
    $('#hero-product-name').textContent=product.name;
    $('#hero-product-note').textContent=mood.note;
    $('#hero-price').textContent=fmt(ui.canvas_from,{price:money(product.minPrice)});
    $('.hero-stage-label').textContent=mood.line;
    $('#hero-open').dataset.product=key;
    $('#hero-name').dataset.product=key;
    $('#hero-open').setAttribute('aria-label',fmt(ui.explore,{name:product.name})); $('#hero-open').href=product.url; $('#hero-name').href=product.url;
  }
  moodButtons.forEach(button => on(button,'click',event => {
    renderMood(button.dataset.mood);
    heroRotator?.choose(event);
  }));
  function makeRotator(root, button, interval, step, {pauseOnHover=false,continueAfterPointerChoice=false}={}) {
    let wantsPlay=Boolean(config.autoplay), inView=false, hovered=false, timer;
    root.style.setProperty('--slide-duration',`${interval/1000}s`);
    function canRun(){return wantsPlay && inView && !hovered && !document.hidden && !$('dialog[open]');}
    function refresh(){
      clearTimeout(timer);root.dataset.running='false';
      button.disabled=false;
      $('.rotation-icon',button).textContent=wantsPlay ? 'Ⅱ' : '▷';
      $('.rotation-label',button).textContent=wantsPlay ? button.dataset.tgId === 'hero-auto' ? ui.pause_showcase : ui.pause : button.dataset.tgId === 'hero-auto' ? ui.play_showcase : ui.play;
      button.setAttribute('aria-label',wantsPlay ? ui.pause_automatic_artwork_slides : ui.play_automatic_artwork_slides);
      root.dataset.playing=String(wantsPlay);
      if(canRun()){
        void root.offsetWidth;root.dataset.running='true';
        timer=setTimeout(()=>{if(canRun())step();refresh();},interval);
      }
    }
    function pause(){wantsPlay=false;refresh();}
    function choose(event){
      if(continueAfterPointerChoice && event.detail>0)refresh();
      else pause();
    }
    on(button,'click',()=>{wantsPlay=!wantsPlay;refresh();});
    if(pauseOnHover){
      on(root,'pointerenter',()=>{hovered=true;refresh();});
      on(root,'pointerleave',()=>{hovered=false;refresh();});
    }
    on(root,'focusin',event=>{
      if(event.target!==button && (!continueAfterPointerChoice || event.target.matches(':focus-visible')))pause();
    });
    makeObserver(entries=>{
      inView=entries[0].isIntersecting && entries[0].intersectionRatio>0.05;
      refresh();
    },{threshold:[0,0.06]}).observe(root);
    on(document,'visibilitychange',refresh);
    $$('dialog').forEach(dialog=>on(dialog,'close',refresh));
    const rotator={pause,choose,refresh,destroy:()=>clearTimeout(timer)};rotators.push(rotator);refresh();return rotator;
  }
  $('.hero-exhibit').setAttribute('role','group');
  $('.hero-exhibit').setAttribute('aria-roledescription','carousel');
  $('.hero-exhibit').setAttribute('aria-label',ui.featured_artwork);
  $('.hero-caption').setAttribute('aria-live','off');
  heroRotator=makeRotator($('#hero'),$('#hero-auto'),config.heroInterval,()=>{
    const keys=Object.keys(moods),index=keys.indexOf($('#hero').dataset.mood);
    renderMood(keys[(index+1)%keys.length]);
  },{continueAfterPointerChoice:true});

  let newIndex=0;
  const newSlides=$$('.new-slide'),newButtons=$$('[data-new-slide]');
  function renderNew(index){
    newIndex=(index+newSlides.length)%newSlides.length;
    $('#new-track').style.transform=`translateX(${-100*newIndex}%)`;
    $('#new-carousel').dataset.index=String(newIndex);
    newSlides.forEach((slide,i)=>{
      slide.setAttribute('aria-hidden',String(i!==newIndex));slide.inert=i!==newIndex;
    });
    setPressed(newButtons,newButtons[newIndex]);
    $('#new-count').textContent=`${String(newIndex+1).padStart(2,'0')} / 03`;
  }
  const newRotator=makeRotator($('#new-carousel'),$('#new-auto'),config.newInterval,()=>renderNew(newIndex+1),{pauseOnHover:false,continueAfterPointerChoice:true});
  newButtons.forEach(button=>on(button,'click',event=>{renderNew(Number(button.dataset.newSlide));newRotator.choose(event);}));
  on($('#new-prev'),'click',event=>{renderNew(newIndex-1);newRotator.choose(event);});
  on($('#new-next'),'click',event=>{renderNew(newIndex+1);newRotator.choose(event);});
  on($('.new-carousel-controls'),'keydown',event=>{
    if(!['ArrowLeft','ArrowRight'].includes(event.key))return;
    event.preventDefault();renderNew(newIndex+(event.key==='ArrowRight'?1:-1));newRotator.pause();
    newButtons[newIndex].focus({preventScroll:true});
  });
  renderNew(0);
  const zoomTargets=[
    {element:$('#hero-art'),anchor:$('.hero-stage'),amount:.035},
    ...$$('.card-art').map(element=>({element,anchor:element.closest('.card-stage'),amount:.085})),
    {element:$('.quiet-art'),anchor:$('.quiet-stage'),amount:.06},
    ...$$('.new-art').map(element=>({element,anchor:$('.new-window'),amount:.06})),
    {element:$('#inspect-display'),anchor:$('#inspect-board'),amount:.045}
  ];
  let zoomFrame;
  function updateZoom(){
    zoomFrame=undefined;
    zoomTargets.forEach(({element,anchor,amount})=>{
      if(!motionEnabled){element.style.setProperty('--scroll-zoom','1');return;}
      const r=anchor.getBoundingClientRect();
      const distance=Math.abs((r.top+r.height/2)-innerHeight/2);
      const influence=Math.max(0,1-distance/(innerHeight/2+r.height/2));
      element.style.setProperty('--scroll-zoom',(1+amount*influence).toFixed(4));
    });
  }
  function requestZoom(){if(zoomFrame===undefined)zoomFrame=requestAnimationFrame(updateZoom);}
  on(window,'scroll',requestZoom,{passive:true});
  on(window,'resize',requestZoom);
  function updateMotion(){
    root.classList.toggle('motion-off',!motionEnabled);
    root.dataset.motion=motionEnabled?'on':'off';
    $('#motion-toggle').setAttribute('aria-pressed',String(motionEnabled));
    $('#motion-toggle').setAttribute('aria-label',motionEnabled?ui.motion_off_label:ui.motion_on_label);
    $('.motion-label').textContent=motionEnabled?ui.motion_on:ui.motion_off;
    rotators.forEach(rotator=>rotator.refresh());updateZoom();
  }
  on($('#motion-toggle'),'click',()=>{motionEnabled=!motionEnabled;updateMotion();});
  on(motionPreference,'change',event=>{if(event.matches){motionEnabled=false;updateMotion();}});
  updateMotion();requestZoom();
  $$('.backdrop-picker').forEach(picker => {
    const buttons=$$('[data-backdrop]',picker);
    buttons.forEach(button => on(button,'click',() => {
      const stage=picker.closest('.card-stage-wrap');
      stage.style.setProperty('--backdrop',button.dataset.backdrop);
      stage.style.setProperty('--tile-ink',button.dataset.ink);
      setPressed(buttons,button);
    }));
  });

  const palettes={
    cow:[[ui.deep_blue,'#092a3a'],[ui.gold,'#ffcd69'],[ui.fuchsia,'#c95b9b'],[ui.teal,'#389fa4']],
    cat:[[ui.teal,'#237b86'],[ui.orange,'#d77836'],[ui.ochre,'#c99d43'],[ui.ink,'#193b45']],
    coast:[[ui.sea_blue,'#2c91bd'],[ui.pink,'#df639d'],[ui.sand,'#edc56c'],[ui.green,'#6ca57c']],
    heart:[[ui.red,'#b92734'],[ui.charcoal,'#393c3d'],[ui.soft_white,'#f0eeea']],
    rooster:[[ui.red,'#cb423b'],[ui.blue,'#267aa4'],[ui.gold,'#dab354'],[ui.green,'#5a9b75']],
    ape:[[ui.ink,'#283733'],[ui.gold,'#cead5d'],[ui.blue,'#4383ac'],[ui.magenta,'#b0588c']]
  };
  let inspectProduct=byKey('cow'),inspectFinish='black',inspectVariant=variantsFor(inspectProduct,'black')[0],activePin;
  const pinButtons=$$('[data-hotspot]'),inspectFinishButtons=$$('[data-inspect-finish]');
  function updateInspectSummary(){
    $('#inspect-name').textContent=inspectProduct.name;
    $('#inspect-variant').textContent=finishName(inspectFinish)+' · '+(inspectVariant.size?inspectVariant.size+' '+ui.inches:inspectVariant.title);
    $('#inspect-price').textContent=money(inspectVariant.price);
  }
  function resetPin(){
    activePin=undefined;
    pinButtons.forEach(button=>button.setAttribute('aria-expanded','false'));
    $('#hotspot-panel').removeAttribute('data-active');$('#hotspot-close').hidden=true;
    $('#hotspot-kicker').textContent=ui.touch_a_detail;
    $('#hotspot-content').innerHTML=ui.a_little_more_to_discover_select_one_of_the_four;
  }
  function showPin(key){
    activePin=key;
    pinButtons.forEach(button=>button.setAttribute('aria-expanded',String(button.dataset.hotspot===key)));
    $('#hotspot-panel').dataset.active=key;$('#hotspot-close').hidden=false;
    const body=$('#hotspot-content');body.replaceChildren();
    const heading=document.createElement('h3');body.append(heading);
    const paragraph=text=>{const p=document.createElement('p');p.textContent=text;body.append(p);};
    const fact=text=>{const p=document.createElement('span');p.className='detail-fact';p.textContent=text;body.append(p);};
    if(key==='canvas'){
      $('#hotspot-kicker').textContent=ui.label_01_canvas_quality;
      heading.innerHTML=ui.canvas_with_substance;
      const number=document.createElement('div');number.className='quality-number';number.textContent=materials.weight;body.append(number);
      paragraph(materials.canvas);
      fact(materials.care);
    }else if(key==='colour'){
      $('#hotspot-kicker').textContent=ui.label_02_colour_print;
      heading.innerHTML=ui.colour_with_character;
      paragraph(descriptions[inspectProduct.key]);
      const colours=document.createElement('div');colours.className='art-colours';
      palettes[inspectProduct.key].forEach(([name,colour])=>{const swatch=document.createElement('span');swatch.className='art-colour';swatch.style.setProperty('--colour',colour);swatch.textContent=name;colours.append(swatch);});body.append(colours);
      fact(materials.inks);
    }else if(key==='frame'){
      $('#hotspot-kicker').textContent=ui.label_03_your_finish;
      heading.innerHTML=inspectFinish==='canvas'?ui.canvas_uncovered:ui.a_frame_that_finishes_it;
      paragraph(inspectFinish==='canvas'?ui.stretched_canvas_has_a_clean_edge_without_a_floa:materials.frame);
      fact(ui.compare_black_white_and_stretched_canvas_using_t);
    }else{
      $('#hotspot-kicker').textContent=ui.label_04_size_proportions;
      heading.innerHTML=ui.find_its_perfect_place;
      paragraph(ui.choose_the_proportions_that_suit_your_wall_and_s);
      const label=document.createElement('label');label.className='hotspot-size-label';label.htmlFor=prefix+'inspect-size';label.textContent=ui.choose_a_size_measurements_in_inches;body.append(label);
      const select=document.createElement('select');select.id=prefix+'inspect-size';select.dataset.tgId='inspect-size';body.append(select);
      inspectVariant=populateSizes(select,inspectProduct,inspectFinish,inspectVariant);
      on(select,'change',()=>{inspectVariant=inspectProduct.variants.find(variant=>variant.id===select.value);updateInspectSummary();});
      fact(ui.measure_your_wall_before_choosing_product_images);
    }
    updateInspectSummary();
  }
  function updateInspect(preferred){
    inspectFinish=ensureFinish(inspectProduct,inspectFinish,inspectFinishButtons,'inspectFinish');const variants=variantsFor(inspectProduct,inspectFinish);
    inspectVariant=variants.find(v=>v.id===preferred?.id)||variants.find(v=>v.size===preferred?.size&&v.wrap===preferred?.wrap)||variants.find(v=>v.size===preferred?.size)||variants[0];
    showArt($('#inspect-art'),inspectProduct,inspectFinish);
    $('#inspect-display').dataset.piece=inspectProduct.key;
    $('#inspect-board').style.setProperty('--inspect-surface',inspectProduct.surface);
    $('#inspect-board').style.setProperty('--inspect-ink',inspectProduct.ink);
    updateInspectSummary();if(activePin)showPin(activePin);
  }
  pinButtons.forEach(button=>on(button,'click',()=>{
    if(activePin===button.dataset.hotspot)resetPin();else showPin(button.dataset.hotspot);
  }));
  on($('#hotspot-close'),'click',()=>{
    const previous=pinButtons.find(button=>button.dataset.hotspot===activePin);resetPin();previous?.focus({preventScroll:true});
  });
  on($('#art-details'),'keydown',event=>{
    if(event.key==='Escape'&&activePin&&!$('dialog[open]')){
      const previous=pinButtons.find(button=>button.dataset.hotspot===activePin);resetPin();previous?.focus({preventScroll:true});
    }
  });
  on($('#inspect-piece'),'change',event=>{inspectProduct=byKey(event.target.value);updateInspect(inspectVariant);});
  inspectFinishButtons.forEach(button=>on(button,'click',()=>{
    inspectFinish=button.dataset.inspectFinish;setPressed(inspectFinishButtons,button);updateInspect(inspectVariant);
  }));
  on($('#inspect-explore'),'click',()=>openProduct(inspectProduct.key,inspectFinish,inspectVariant));
  updateInspect();

  let roomProduct=byKey('cow'),roomFinish='black',roomVariant;
  function updateRoom(preferred) {
    roomFinish=ensureFinish(roomProduct,roomFinish,$$('[data-room-finish]'),'roomFinish');roomVariant=populateSizes($('#room-size'),roomProduct,roomFinish,preferred);
    showArt($('#room-art'),roomProduct,roomFinish);
    $('#room-art').setAttribute('aria-label',fmt(ui.explore,{name:roomProduct.name}));
    $('#room-name').textContent=roomProduct.name;
    $('#room-price').textContent=money(roomVariant.price);
    $('#room-variant-note').textContent=finishName(roomFinish)+' · '+(roomVariant.size?roomVariant.size+' '+ui.inches:roomVariant.title);
  }
  const roomButtons=$$('[data-room-piece]');
  roomButtons.forEach(button => on(button,'click',() => {
    roomProduct=byKey(button.dataset.roomPiece);
    setPressed(roomButtons,button);
    updateRoom(roomVariant);
  }));
  const roomFinishButtons=$$('[data-room-finish]');
  roomFinishButtons.forEach(button => on(button,'click',() => {
    roomFinish=button.dataset.roomFinish;
    setPressed(roomFinishButtons,button);
    updateRoom(roomVariant);
  }));
  on($('#room-size'),'change',event => {
    roomVariant=roomProduct.variants.find(variant => variant.id === event.target.value);
    $('#room-price').textContent=money(roomVariant.price);
    $('#room-variant-note').textContent=finishName(roomFinish)+' · '+(roomVariant.size?roomVariant.size+' '+ui.inches:roomVariant.title);
  });
  const wallButtons=$$('[data-wall]').filter(element => element.tagName === 'BUTTON');
  wallButtons.forEach(button => on(button,'click',() => {
    setPressed(wallButtons,button);
    $('#room-scene').dataset.wall=button.dataset.wall;
  }));
  on($('#room-detail'),'click',event => {event.preventDefault();openProduct(roomProduct.key,roomFinish,roomVariant);});
  on($('#room-art'),'click',event => {event.preventDefault();openProduct(roomProduct.key,roomFinish,roomVariant);});
  updateRoom();

  const productDialog=$('#product-dialog'); function syncPurchase(){if(!activeVariant)return;$('#detail-add').disabled=!activeVariant.available;$('#detail-add').textContent=activeVariant.available?ui.add_to_cart:ui.sold_out;const link=$('[data-tg-id=product-page]');if(link)link.href=activeProduct.url+'?variant='+activeVariant.id;}
  let activeProduct=products[0],activeFinish='black',activeVariant; 
  const finishButtons=$$('[data-finish]');
  function updateDetail(preferred){
    activeFinish=ensureFinish(activeProduct,activeFinish,finishButtons,'finish');activeVariant=populateSizes($('#detail-size'),activeProduct,activeFinish,preferred);
    $('#detail-price').textContent=money(activeVariant.price); syncPurchase();
    showArt($('#detail-art'),activeProduct,activeFinish);
  }
  function openProduct(key,finish='black',preferred){
    activeProduct=byKey(key);activeFinish=finish;
    $('#detail-title').textContent=activeProduct.name;
    $('#detail-description').textContent=descriptions[key];
    $('#detail-eyebrow').textContent=key === 'heart' ? ui.a_quiet_statement : key === 'coast' ? ui.a_change_of_scenery : ui.full_of_colour_and_character;
    const stage=$('.detail-stage');
    stage.style.setProperty('--detail-surface',activeProduct.surface);
    stage.style.setProperty('--detail-ink',activeProduct.ink);
    setPressed(finishButtons,finishButtons.find(button => button.dataset.finish === finish));
    updateDetail(preferred);
    productDialog.showModal();productDialog.scrollTop=0;rotators.forEach(rotator=>rotator.refresh());
  }
  $$('[data-product]').forEach(button => on(button,'click',event => {event.preventDefault();openProduct(button.dataset.product);}));
  finishButtons.forEach(button => on(button,'click',() => {
    activeFinish=button.dataset.finish;
    setPressed(finishButtons,button);
    updateDetail(activeVariant);
  }));
  on($('#detail-size'),'change',event => {
    activeVariant=activeProduct.variants.find(variant => variant.id === event.target.value);
    $('#detail-price').textContent=money(activeVariant.price); syncPurchase();
  });
  $$('[data-close-dialog]').forEach(button => on(button,'click',() => button.closest('dialog').close()));
  $$('dialog').forEach(dialog => on(dialog,'click',event => {
    const r=dialog.getBoundingClientRect();
    if(event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom))dialog.close();
  }));


  on($('#help-open'),'click',()=>{$('#help-dialog').showModal();rotators.forEach(r=>r.refresh());});
  on($('#help-room'),'click',()=>$('#help-dialog').close());
  renderMood('cow');
  root.dataset.ready='true';
  return ()=>{abort.abort();observers.forEach(o=>o.disconnect());rotators.forEach(r=>r.destroy());if(zoomFrame!==undefined)cancelAnimationFrame(zoomFrame);$$('dialog[open]').forEach(d=>d.close());};

  }
}
if(!customElements.get('tg-gallery-home'))customElements.define('tg-gallery-home',TgGalleryHomepage);
